import React from "react";
import ExpiryIcon from "images/ExpireAtricle.svg"
import Button from "storybookComponents/Button";
const style = {
  pageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 104px)",
    flexDirection: "column",
    background: "white",
    fontFamily: "Open Sans",
    margin: 20,
    border: '1px solid #dadada'
  },
  header: {
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "28px",
    lineHeight: "48px",
    color: "#333333",
    textAlign: "center",
  },
  title: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "20px",
    lineHeight: "30px",
    textAlign: "center",
    color: "rgba(51, 51, 51, 0.75)",
    marginTop: "12px",
  },
  button: {
    width: "178px",
    height: "40px",
    marginTop: "16px",
    textTransform: 'none',
    lineHeight: '20px'
  },
  lineDiv: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "16px",
    color: "rgba(51, 51, 51, 0.5)",
    fontSize: "12px",
    lineHeight: "18px",
  },
  line: {
    width: "60px",
    height: "1px",
    background: "#EEEEEE",
  },
  liveOr: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    textAlign: "center",
    color: "rgba(51, 51, 51, 0.5)",
  },
};

var expiredCount = 10;
const ExpiredPage = (props) => {
  const [timer, setTimer] = React.useState(expiredCount);
  React.useEffect(() => {
    expiredCount = 10;
    let countDown = setInterval(async () => {
      if (expiredCount === 0) {
        clearInterval(countDown);
        handleClick()
      } else {
        expiredCount = expiredCount - 1;
        await setTimer(expiredCount);
      }
    }, 1000);
    return () => { clearInterval(countDown); }
  }, []);

  const handleClick = () => {
    window.open(process.env.REACT_APP_JAI_hostName + "/" + props.match.params.propertyId + "/events", "_blank");
  }

  return (
    <div style={style.pageContainer}>
      <div style={{ textAlign: "center" }}>
        <img alt="expiry_Image" src={ExpiryIcon} />
      </div>
      <div style={style.header}>hyEvents is no longer available</div>
      <div style={style.title}>
        You will be redirected to <b>Journey AI - Events</b> in {timer}s
      </div>
      <div style={style.lineDiv}>
        <div style={style.line}></div>
        or
        <div style={style.line}></div>
      </div>
      <div>
        <Button onClick={handleClick} style={style.button}>Go To Events Now</Button>
      </div>
    </div>
  );
};

export default ExpiredPage;